import Vue from "vue";
import Vuex from "vuex";
import { namespace } from "./types";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import Oidc from "oidc-client";

Vue.use(Vuex);

// STATE
const state = {
	counter: 1,
	[namespace.OIDC]: {
		user: null,
		authenticated: false,
		instance: null,
		token: null,
		config: {
			userStore: new Oidc.WebStorageStateStore(),
			authority: process.env.VUE_APP_authority,
			client_id: "FertigungClient", // Client application's identifier as registered on the Identityserver
			redirect_uri: process.env.VUE_APP_redirectUri, // Redirect URI of your client application to receive a response from the Identityserver
			post_logout_redirect_uri: process.env.VUE_APP_postLogoutRedirectUri, // The Identityserver post-logout redirect URI.
			response_type: "id_token token", // The type of response desired from the Identityserver
			scope: "openid profile email FertigungApi EventApi offline_access", // The scope being requested from the Identityserver
			automaticSilentRenew: true, // Flag to indicate if there should be an automatic attempt to renew the access token prior to its expiration. The attempt is made as a result of the accessTokenExpiring event being raised
			silent_redirect_uri: window.location.origin + "/silent-renew.html",
			loadUserInfo: true,
		},
	},
	// if the navigation drawer is visible or not
	drawer: false,
	// all loaded Fertigers
	fertiger: [],
	// all loaded transport provider
	transportProviders: [],
	// count of tickets for current manufacturer
	beanstandungsCount: 0,
	// for which fertiger are tickets loaded
	beanstandungLoadedForFertigerId: undefined,
	// order cancellation requests
	orderCancellationRequests: null,
	// show resolved tickets or not
	showResolved: false,
};

export default new Vuex.Store({
	state,
	mutations,
	actions,
	getters,
});
